import React, { useContext } from "react";
import MyContext from "../../../StoreContext";
import RetailMessage from "./RetailMessage";
import BankMessage from "./BankMessage";
import InsuranceMessage from "./InsuranceMessage";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import stepThree from "./assets/stepThree.svg";

/**
 * Componente que tiene la logica para mostrar
 * la lista de mensajes segun el rubro selecionado
 * Este es el tercer paso del flujo de la automatizacion
 */
const Messages = () => {
  const { industry } = useContext(MyContext);
  let component: JSX.Element;

  switch (industry) {
    case "retail":
      component = <RetailMessage />;
      break;
    case "bank":
      component = <BankMessage />;
      break;
    case "insurance":
      component = <InsuranceMessage />;
      break;
    default:
      component = <div>no message</div>;
  }

  return (
    <Stack direction='column' spacing={2}>
      <Grid container>
        <img src={stepThree} alt='stepThree' />
      </Grid>
      <Grid>{component}</Grid>
    </Stack>
  );
};

export default Messages;
